import { render, staticRenderFns } from "./Openstaand.vue?vue&type=template&id=4e33fd6a"
import script from "./Openstaand.vue?vue&type=script&lang=js"
export * from "./Openstaand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports